import type { StreamTileView } from "../stream-tiles";

export type StageState = {
  participantsToggleVisible: boolean;
  participantCardsHidden: boolean;
  emptyStageVisible: boolean;
  streamTiles: StreamTileView[];
  streamFocusActive: boolean;
  focusedOverlaysVisible: boolean;
  focusName: string;
  focusPicture: string;
  focusLive: boolean;
  focusCloseVisible: boolean;
  focusStoppingWatch: boolean;
  focusVolumeVisible: boolean;
  focusVolumeAvailable: boolean;
  focusVolumeOpen: boolean;
  focusVolume: number;
  focusMuted: boolean;
  focusViewVisible: boolean;
  focusPipAvailable: boolean;
};

export const initialStageState: StageState = {
  participantsToggleVisible: false,
  participantCardsHidden: false,
  emptyStageVisible: true,
  streamTiles: [],
  streamFocusActive: false,
  focusedOverlaysVisible: false,
  focusName: "",
  focusPicture: "",
  focusLive: false,
  focusCloseVisible: false,
  focusStoppingWatch: false,
  focusVolumeVisible: false,
  focusVolumeAvailable: false,
  focusVolumeOpen: false,
  focusVolume: 0,
  focusMuted: true,
  focusViewVisible: false,
  focusPipAvailable: false,
};

// Pure visibility: no timer, DOM or SDK access. Returns a primitive snapshot.
export function selectParticipantRowHidden(state: { stage: StageState }): boolean {
  return state.stage.streamFocusActive && state.stage.participantCardsHidden;
}
